import { KeyboardArrowDown } from "@mui/icons-material";
import {
  Box,
  Collapse,
  Fade,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import VideoBackgroundContainer from "components/shared/VideoBackgroundContainer";
import { usePageContext } from "contexts/PageContextProvider";
import { useEffect, useState } from "react";
import { Link } from "react-scroll";
// assets
import FlareBackgroundVideo from "assets/videos/page-backgrounds/istockphoto-flare.mp4";

/**
 * * Landing section of the Homepage
 * @returns {React.ReactElement} Landing
 */
export default function Landing() {
  const [firstTransition, setFirstTransition] = useState(false);
  const [secondTransition, setSecondTransition] = useState(false);
  const [thirdTransition, setThirdTransition] = useState(false);

  const { scrollOffset, scrollDurationMs } = usePageContext();

  const greaterThanMd = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const greaterThanSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  useEffect(() => {
    setTimeout(() => {
      setFirstTransition(true);
    }, 1000);
    setTimeout(() => {
      setSecondTransition(true);
    }, 3000);
    setTimeout(() => {
      setThirdTransition(true);
    }, 5000);
  });

  return (
    <Box id="Landing" height="100vh">
      <VideoBackgroundContainer src={FlareBackgroundVideo}>
        {/* Box for background blur */}
        <Box height="100%" sx={{ backgroundColor: "#4442" }}>
          <Box
            height="95%"
            display="flex"
            flexDirection="column"
            align="center"
            alignItems="center"
            justifyContent="center"
            backgroundColor="none"
            sx={{ pt: { xs: 2, md: 0 } }}
          >
            <Typography
              variant="h1"
              letterSpacing={{ xs: "0.6rem", md: "0.8rem" }}
            >
              EXPLORE {!greaterThanSm && <br />} THE {!greaterThanSm && <br />}{" "}
              UNEXPLORED
            </Typography>
            {/* SPACING BOX */}
            <Box height={greaterThanMd ? 10 : 30} />
            <FadeCollapse
              duration={4000}
              trigger={firstTransition}
              orientation="vertical"
            >
              <Typography variant="h1" fontWeight="bold">
                DISCOVER {!greaterThanSm && <br />} THE{" "}
                {!greaterThanSm && <br />} UNDISCOVERED
              </Typography>
            </FadeCollapse>
            {/* SPACING BOX */}
            <Box height={60} />
            <FadeCollapse duration={5000} trigger={secondTransition}>
              <Typography variant="h5" letterSpacing=".15rem" noWrap>
                AI EMPOWERED {!greaterThanMd && <br />}
                <b>EARLY CANCER {!greaterThanSm && <br />}DETECTION</b>
              </Typography>
            </FadeCollapse>
          </Box>
          <Box
            height="5%"
            display="flex"
            alignItems="flex-end"
            justifyContent="center"
          >
            <Fade timeout={5000} in={thirdTransition}>
              <IconButton>
                <Link
                  to="About"
                  smooth={true}
                  duration={scrollDurationMs}
                  offset={scrollOffset}
                >
                  <KeyboardArrowDown
                    color="primary"
                    fontSize="large"
                    sx={{ m: 1 }}
                  />
                </Link>
              </IconButton>
            </Fade>
          </Box>
        </Box>
      </VideoBackgroundContainer>
    </Box>
  );
}

/**
 * * Fade In element during Collapse In
 * @param {Object} props
 * @param {number} props.duration
 * @param {boolean} props.trigger
 * @param {string} [props.orientation="horizontal"]
 * @param {React.ReactElement} props.children
 * @returns {React.ReactElement} FadeCollapse
 */
function FadeCollapse({
  duration,
  trigger,
  orientation = "horizontal",
  children,
}) {
  if (duration < 1000) {
    throw new Error("Duration must be greater than 1000");
  }
  return (
    <Fade in={trigger} timeout={duration}>
      <Box overflow="hidden">
        <Collapse
          in={trigger}
          orientation={orientation}
          timeout={duration - 1000}
        >
          {children}
        </Collapse>
      </Box>
    </Fade>
  );
}
